<template>
  <div class="text-xs-center">
    <v-btn
      fab
      color="secondary"
      dark
      right
      bottom
      fixed
      large
      class="offset-fab"
      @click="openDialog();">
      <v-icon>mdi-image-plus</v-icon>
    </v-btn>

    <v-dialog
      v-model="dialog.main"
      persistent
      fullscreen
      transition="dialog-bottom-transition">
      <!-- 登録中のロード画面 -->
      <v-overlay :value="overlay">
        <v-progress-circular
          indeterminate
          size="64" />
      </v-overlay>

      <!-- 登録画面 -->
      <v-card>
        <v-toolbar
          dark
          dense
          fixed
          color="secondary">
          <v-icon class="mr-3">
            mdi-image-plus
          </v-icon>
          <v-toolbar-title class="mt-1">
            登録
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            dark
            @click="dialog.main = false; resetInput();">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-layout
          wrap
          justify-center>
          <v-flex
            xs12
            sm10
            md6>
            <v-form
              ref="form"
              v-model="valid">
              <v-container fluid>
                <v-layout
                  wrap
                  justify-center>
                  <picture-input
                    ref="pictureInput"
                    class="mt-5"
                    margin="50"
                    width="400"
                    height="400"
                    accept="image/jpeg,image/png"
                    size="10"
                    button-class="v-btn v-btn--flat v-btn--text v-size--x-small secondary--text"
                    removeButtonClass="v-btn v-btn--flat v-btn--text v-size--x-small error--text"
                    :removable="true"
                    :custom-strings="{
                      drag: 'drag your 📷',
                      tap: 'select your 📷',
                      change: 'change',
                      remove: 'clear',
                    }"
                    @change="onChange"
                    @remove="onRemove" />

                  <v-flex
                    xs11
                    py-0
                    class="mt-5">
                    <v-select
                      v-model="input.prefecture"
                      prepend-icon="mdi-earth"
                      :items="prefectures"
                      :rules="rules.prefecture"
                      required
                      color="secondary"
                      item-text="name"
                      item-value="id"
                      label="* 都道府県" />
                  </v-flex>

                  <v-flex
                    xs11
                    py-0>
                    <v-dialog
                      v-model="dialog.date"
                      width="290px">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="input.registeredDate"
                          :rules="rules.registeredDate"
                          required
                          color="secondary"
                          label="* 行った日"
                          prepend-icon="mdi-calendar-month"
                          readonly
                          v-on="on" />
                      </template>
                      <v-date-picker
                        v-model="date"
                        color="secondary"
                        my-0
                        no-title />
                    </v-dialog>
                  </v-flex>

                  <v-flex
                    xs11
                    py-0>
                    <v-text-field
                      v-model="input.place"
                      required
                      :rules="rules.place"
                      color="secondary"
                      label="* 場所"
                      prepend-icon="mdi-map-marker-radius" />
                  </v-flex>

                  <v-flex
                    xs11
                    py-0>
                    <v-textarea
                      v-model="input.content"
                      color="secondary"
                      label="思い出"
                      prepend-icon="mdi-pencil"
                      rows="1"
                      auto-grow />
                  </v-flex>

                  <v-flex
                    xs11
                    py-0>
                    <v-row
                      justify="center"
                      align="center"
                      class="mt-2">
                      <v-btn-toggle
                        v-model="input.isPublic"
                        class="text-center">
                        <v-btn
                          small
                          value="true">
                          {{ label.public }}
                        </v-btn>
                        <v-btn
                          small
                          value="false">
                          {{ label.private }}
                        </v-btn>
                      </v-btn-toggle>
                    </v-row>
                  </v-flex>

                  <v-flex
                    xs11
                    py-0>
                    <v-row
                      xs11
                      justify="end"
                      class="py-0 mt-1 mr-1">
                      <v-btn
                        text
                        color="grey"
                        class="caption"
                        @click="openPublicHelp();">
                        公開/非公開について
                      </v-btn>
                    </v-row>
                  </v-flex>

                  <v-flex
                    xs11
                    py-0>
                    <v-card-actions>
                      <v-flex xs12>
                        <div class="text-center">
                          <v-btn
                            text
                            :disabled="!valid"
                            color="secondary"
                            @click="createMemory();">
                            登録
                          </v-btn>
                        </div>
                      </v-flex>
                    </v-card-actions>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <!-- 公開非公開についての説明ダイアログ -->
    <v-dialog
      v-model="dialog.publicHelp"
      width="600px">
      <v-card>
        <PublicIntroductionDialog />

        <v-row
          justify="center"
          no-gutters>
          <v-card-actions>
            <v-btn
              color="primary"
              text
              @click="dialog.publicHelp = false;">
              確認
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.offset-fab {
  margin-bottom: 50px;
}
</style>

<script>
import PictureInput from 'vue-picture-input';
import PublicIntroductionDialog from '../Dialogs/PublicIntroductionDialog';

import prefecture from '../../data/prefecture';
import dataStore from '../../libs/dataStore';
import ga from '../../libs/ga';
import labelString from '../../data/labelString';

const generate = require('nanoid/generate');

export default {
  components: {
    PictureInput,
    PublicIntroductionDialog,
  },
  data() {
    return {
      valid: true,
      overlay: false,
      dialog: {
        main: false,
        date: false,
        publicHelp: false,
      },
      date: null,
      prefectures: [],
      input: {
        image: null,
        prefecture: null,
        registeredDate: null,
        place: null,
        content: null,
        isPublic: 'true',
      },
      hasImage: false,
      params: null,
      rules: {
        prefecture: [v => !!v || '入力必須です'],
        registeredDate: [v => !!v || '入力必須です'],
        place: [v => !!v || '入力必須です'],
      },
      label: {
        public: labelString.public,
        private: this.$store.state.isSelectWithPartner ? labelString.privateWith : labelString.privateOnly,
      },
    };
  },
  watch: {
    date () {
      this.input.registeredDate = this.formatDate(this.date);
      this.dialog.date = false;
    },
    '$store.state.isSelectWithPartner': function() {
      this.label.private = this.$store.state.isSelectWithPartner ? labelString.privateWith : labelString.privateOnly;
    },
  },
  created: function() {
    // 都道府県のセレクトを作成
    for (let [key, value] of Object.entries(prefecture)) {
      this.prefectures.push({
        id: key,
        name: value,
      });
    }
  },
  methods: {
    openDialog: function() {
      ga.fab.openCreate(this.$ga);

      this.dialog.main = true;
      this.input.prefecture = this.$route.params.prefectureId;
    },
    openPublicHelp: function() {
      ga.fab.helpCreate(this.$ga);
      this.dialog.publicHelp = true;
    },
    createMemory: async function() {
      if (this.$refs.form.validate()) {
        ga.fab.create(this.$ga);
        this.overlay = true;

        const params = {
          id: `M${generate('abcdefghijklmnopqrstuvwxyz0123456789', 8)}`,
          prefecture: this.input.prefecture,
          place: this.input.place,
          registeredDate: this.input.registeredDate,
          isPublic: this.input.isPublic,
        };

        if (this.input.content) params.content = encodeURIComponent(this.input.content);
        if (this.hasImage) {
          let canvas = document.getElementsByClassName('picture-preview')[0];
          params.image = canvas.toDataURL('image/jpeg', 1.0);
        }

        const success = await dataStore.putMemory(this.$store.state.currentUserId, params);
        this.overlay = false;

        if (success) {
          this.dialog.main = false;
          this.resetInput();

          this.$store.dispatch('showSnackbar', {
            ga: this.$ga,
            snackbar: {
              color: 'success',
              text: '思い出を登録しました',
            },
          });

          // 思い出一覧を再取得させる
          this.$store.commit('reloadMemories');
        } else {
          this.$store.dispatch('showSnackbar', {
            ga: this.$ga,
            snackbar: {
              color: 'error',
              text: '登録に失敗しました',
            },
          });
        }
      }
    },
    resetInput: function () {
      this.$refs.form.reset();
      this.$refs.pictureInput.removeImage();
    },
    formatDate: function (date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${year}/${month}/${day}`;
    },
    onChange: function (image) {
      if (image) this.hasImage = true;
    },
    onRemove: function () {
      this.hasImage = false;
    },
  },
};
</script>